export default "__VITE_ASSET__5U4UWuxg__"